import React from "react";
import {Link} from "react-router-dom";
import Cricketball from "../Statics/cricketball.png";
import Stadium from "../Statics/Stadium.png";
import Matches from "../Statics/Matches.png";
import Points from "../Statics/Pointstables.png";

const Home = () => {
    return ( 
        <>
        <div class="card text-center m-5">
           
            <div class="card-body">
                <h5 class="card-title"  >Countries/Teams</h5>
              <p>This event is organized by or honorable Prime Minister Narendra Modi Ji</p>
              <img src={Cricketball}  class="d-inline-block align-top"  alt="" />
                
            </div>
        
            <Link to="/teams" class="btn btn-primary">TEAM DETAILS</Link>
        </div>
        <div class="card text-center m-5">
           
            <div class="card-body">
                <h5 class="card-title"  >Venues</h5>
              <p>This game are being played in various parts of India with a total 6 States from south to north to east and to the west.</p>
              <img src={Stadium} width="250px" height="280px" class="d-inline-block align-top"  alt="" />
                
            </div>
        
            <Link to="/venues" class="btn btn-primary">Venue Details</Link>
        </div>
        <div class="card text-center m-5">
           
           <div class="card-body">
               <h5 class="card-title" >Matches</h5>
             <p>The matches in this tournment are played against the best teams in the world.</p>
             <img src={Matches} width="250px" height="280px" class="d-inline-block align-top"  alt="" />
               
           </div>
       
           <Link to="/matches" class="btn btn-primary">Matches Details</Link>
       </div>
       <div class="card text-center m-5">
           
           <div class="card-body">
               <h5 class="card-title" >Points Table</h5>
             <p>The matches played by every team are equal as each team playes with each team two twice. Every match win get 2 points for the team and the team with the highest points win.</p>
             <img src={Points} width="250px" height="280px" class="d-inline-block align-top"  alt="" />
               
           </div>
       
           <Link to="/points" class="btn btn-primary">Points table</Link>
       </div>
    </>
     );
}
 
export default Home;